/* unplugin-vue-components disabled */import { render } from "./AddSong.vue?vue&type=template&id=50ffd1e0&ts=true"
import script from "./AddSong.vue?vue&type=script&lang=ts"
export * from "./AddSong.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Song\\Demo\\hxswmj\\hxswmj_vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__